// A Cloudinary url is cropped to its use ( c_fill,w_..,h_.. ). Leaving those
// transformations out makes Cloudinary serve the uploaded original untouched.
// Other urls (e.g. blob: previews of a picked file) are returned as is.
export const getOriginalUrl = (url: string) =>
  url.replace(/\/upload\/(?:[a-z]{1,3}_[^/]+\/)*/, "/upload/");
